import { rootStore } from 'stores'
import { invalidateOrgTeamTree } from 'components/DashboardBanners/OrgTeamSwitcher/use-org-team-tree'

/**
 * Reset every MobX store that caches organization/profile-scoped data.
 *
 * Called immediately after the active play profile changes (Player <-> Coach)
 * so a freshly-activated profile never observes another profile's stale list or
 * detail caches. The active-profile switch already refetches memberships in
 * `authStore`; this clears the downstream domain stores those views read from.
 *
 * Keep this list the single source of truth — when a new org-scoped store is
 * added, register its `reset()` here rather than wiring cleanup per call site.
 */
export function clearOrgScopedStores(): void {
  rootStore.processStore.reset()
  rootStore.collectionStore.reset()
  rootStore.trainingPlanStore.reset()
  rootStore.playerAssignmentStore.reset()
  rootStore.messageStore.reset()
  rootStore.scheduleStore.reset()
  // Not a store, but the same hazard: the org/Team tree behind the context
  // switcher is cached at module scope and `GET /users/me/teams` answers for the
  // *active profile*. Left alone, a coach who switched profiles without a reload
  // would be offered the athlete profile's organizations — and picking one asks
  // the dashboard for an organization they are not staff in.
  invalidateOrgTeamTree()
}
